/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $boxModal  = $el.find('.wrapper-modal');
const $openModal = $('[data-open-modal-form]');
const $btnClose  = $el.find('.btn-close-modal');
const lang       = $('html').attr('lang');

const open = (origin) => {
    TweenLite.set($boxModal, {y:-50});

    TweenLite.to($el, .4,{display:'block', opacity: 1, onComplete: function(){
        $body.addClass('modal-open');
    }});

    TweenLite.to($boxModal, .4, {y:0});

    $el.find('input[name="origin"]').val(origin);

    let val = $el.find('input[name="origin"]').val();
};

const close = () => {
    TweenLite.to($el, .4,{display:'none', opacity: 0, onComplete: function(){
        $body.removeClass('modal-open');
    }});

    TweenLite.to($boxModal, .4, {y:-50});
};

$openModal.on('click', function(){
    const origin = $(this).data('open-modal-form');
    open(origin);
});

$btnClose.on('click', function(){
    close();
});

$body.on('click', function (e) {
    if ($body.is('.modal-open') && !$(e.target).closest('.box-modal').length) {
        close();
    }
});

var maskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
options = {
    onKeyPress: function (val, e, field, options) {
        field.mask(maskBehavior.apply({}, arguments), options);
    }
};

$('.field-phone').mask(maskBehavior, options);

let rules = {
    name: {
        required: true,
        minlength: 3,
    },
    email: {
        required: true,
        email: true
    },
    phone: {
        required: true,
        minlength: 14,
        maxlength: 15,
    },
    accept_terms: {
        required: true,
    }
};
let messages = {
    name: {
        required: lang == 'pt-br' ? "O nome é obrigatório" : "The name is mandatory",
        minlength: lang == 'pt-br' ? "O nome deve ter no mínimo 3 caracteres" : "The name must have at least 3 characters",
    },
    email: {
        required: lang == 'pt-br' ? "O e-mail é obrigatório" : "The e-mail is mandatory",
        email: lang == 'pt-br' ? "E-mail inválido" : "Invalid e-mail",
    },
    phone: {
        required: lang == 'pt-br' ? "O celular é obrigatório": "The cell phone is mandatory",
        minlength: lang == 'pt-br' ? "O celular deve ter no mínimo 14 caracteres" : "The cell phone must have at least 14 characters",
        maxlength: lang == 'pt-br' ? "O celular deve ter no máximo 15 caracteres" : "The cell phone must have a maximum of 15 characters",
    },
    accept_terms: {
        required: lang == 'pt-br' ? "Você precisa aceitar os termos": "You need to accept the terms",
    }
};

$el.find('form').validate({
    errorElement: 'span',
    errorClass: 'error',
    rules: rules,
    messages: messages,
    errorPlacement: function(error, element) {

        $(element).closest('.row-input').find('.msg-error').html(error);
    },
    highlight: function ( element, errorClass, validClass ) {
        $( element ).closest('.row-form').addClass('row-error');
        $( element ).addClass('error');
    },

    unhighlight: function (element, errorClass, validClass) {
        $( element ).closest('.row-form').removeClass('row-error');
        $( element ).removeClass('error');
    },
    submitHandler: function (form) {
        var $form = $(form);
        let formData = $form.serialize();
        letFormArr = $form.serializeArray();

        if ($form.hasClass('sending')) {
            return false;
        }

        $form.addClass('sending');
        if(lang == 'pt-br'){
            $form.find('.btn-send').text('Enviando...');
        } else {
            $form.find('.btn-send').text('Send...');
        }

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: formData
        }).done(function (data) {
            if (!data.error) {
                $form[0].reset();
            } else {
                alert("Falha no envio.");
            }
        }).fail(function () {
            alert("Falha no envio.");
        }).always(function () {
            $form[0].reset();
            $form.removeClass('sending');
            $form.find('label').removeClass('active');
            if(lang == 'pt-br'){
                $form.find('.btn-send').text('Quero investir');
            } else {
                $form.find('.btn-send').text('Invest');
            }
        });

        window.open('https://cadastro-prd.singulare.com.br/wm/iportal/auth/newAutoCadastroPortal', '_blank');

        close();

        return false;
    }
});

$el.find('input[type=text], input[type=email], textarea').on('focus change', function(){
    $(this).closest('.row-form').find('label').addClass('active');
});

$el.find('input[type=text], input[type=email], textarea').on('blur', function(){
    if($(this).val()){
        $(this).closest('.row-form').find('label').addClass('active');
    } else {
        $(this).closest('.row-form').find('label').removeClass('active');
    }
});
